"use client"

import { useEffect, useState } from "react"

const Sidebar = ({
  role,
  handleOpenChangePasswordModal,
  handleOpenAddUserModal,
  handleOpenResetPasswordModal,
  handleSignOut,
  isGuestUser,
  username,
  tenantname,
}) => {
  const [displayUsername, setDisplayUsername] = useState(username || localStorage.getItem("username") || "")
  const [displayTenant, setDisplayTenant] = useState(tenantname || localStorage.getItem("tenantname") || "")
  const [userRole, setUserRole] = useState(localStorage.getItem("role") || role)

  useEffect(() => {
    setDisplayUsername(username || localStorage.getItem("username") || "")
    setDisplayTenant(tenantname || localStorage.getItem("tenantname") || "")
    setUserRole(localStorage.getItem("role") || role)
  }, [username, tenantname, role])

  const guest = typeof isGuestUser === "boolean" ? isGuestUser : sessionStorage.getItem("isGuestUser") === "true"

  return (
    <div className="sidebar">
      <div className="logo-container">
        <img src="/logo.png" alt="logo" className="logo" />
      </div>

      {!guest && (
        <>
          <button className="sidebar-btn" onClick={handleOpenChangePasswordModal}>
            Change Password
          </button>
          <button className="sidebar-btn" onClick={handleOpenResetPasswordModal}>
            Reset Password
          </button>
          <button className="sidebar-btn" onClick={handleSignOut}>
            Sign Out
          </button>

          <div className="user-info">
            <h4>User Details</h4>
            <p className="user-detail">
              <strong>Email:</strong> {displayUsername}
            </p>
            <p className="user-detail">
              <strong>Customer:</strong> {displayTenant}
            </p>
          </div>
        </>
      )}
    </div>
  )
}

export default Sidebar
